import { render } from "./Loading.vue?vue&type=template&id=caf26b38&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=caf26b38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf26b38"]])

export default __exports__